/// <amd-module name="Wit/Deployment/telemetry/Deployments" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";
import { IVssTraceService } from "VSS/Platform/Trace";
import { WITCustomerIntelligenceArea } from "Wit/Common/Constants/CustomerInteligence";

export const WITCIDeploymentsIntegrationFeature = "DeploymentsIntegration";

export namespace DeploymentsIntegrationCIActions {
    export const SHOW_ZERO_DATA = "SHOW_ZERO_DATA";
    export const SHOW_DEPLOYMENTS = "SHOW_DEPLOYMENTS";
    export const TOGGLE_PIPELINE = "TOGGLE_PIPELINE";
}

export function publishDeploymentsIntegrationTrace(pageContext: IVssPageContext, message: string, properties: { [key: string]: any } = {}) {
    const traceService = pageContext.getService<IVssTraceService>("IVssTraceService");
    traceService.traceError(WITCustomerIntelligenceArea, WITCIDeploymentsIntegrationFeature, message, properties);
}

export function publishDeploymentsTelemetry(pageContext: IVssPageContext, action: string, properties: { [key: string]: any } = {}) {
    const telemetryService = pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
    telemetryService.publishEvent(WITCustomerIntelligenceArea, WITCIDeploymentsIntegrationFeature, {
        action,
        ...properties
    });
}
